module.exports = __webpack_public_path__ + "static/media/doklad_ok_2016.6a46ad9f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/doklad_ok_2016.pdf
// module id = 161
// module chunks = 0